'use client';

import * as a from "react";
import p from "../lib/IconBase.es.js";
import e from "../defs/Warning.es.js";
const r = a.forwardRef((n, a$1) => /* @__PURE__ */ a.createElement(p, { ref: a$1, ...n, weights: e }));
r.displayName = "WarningIcon";
const c = r;
export {
  c as Warning,
  r as WarningIcon
};
